import * as React from 'react';

import { ImagePlaceholder } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';
import { useOnTap } from '@hooks/useOnTap';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';
import { trackProductImageTap } from '../tracking';

import { ImgWrapper } from './styled';

import { IImageSliderProps } from '.';

interface Props {
  index: number;
  imgProps: IImageSliderProps['imagesAttrs'][number];
}

export const ResizableImagePlaceholder: React.FC<
  React.PropsWithChildren<Props>
> = ({ index, imgProps, children }) => {
  const newPdDesign = useNewPdDesignEnabled();
  const [isSquare, setIsSquare] = React.useState(false);

  const { getTimeFromInit } = useTrackingContext();
  const ref = useOnTap<HTMLDivElement>(() =>
    trackProductImageTap({ timing: getTimeFromInit() })
  );

  const handleImageLoad = (elem: HTMLImageElement) => {
    setIsSquare(
      elem.naturalWidth === elem.naturalHeight &&
        index !== 0 &&
        !imgProps.src.includes('-o/')
    );
  };

  return (
    <ImgWrapper ref={ref} newPdDesign={newPdDesign} isSquare={isSquare}>
      <ImagePlaceholder
        // Don't display placeholder for the first image in the slider.
        // An image replace placeholder when is loaded and after react is hydrated.
        // React hydration can take some time and we want first image to show immediately when loaded.
        hidePlaceholder={index === 0}
        image={imgProps}
        onLoad={handleImageLoad}
      />
      {children}
    </ImgWrapper>
  );
};
